import { render, staticRenderFns } from "./OnePage.vue?vue&type=template&id=4138abe5&scoped=true&"
import script from "./OnePage.vue?vue&type=script&lang=ts&"
export * from "./OnePage.vue?vue&type=script&lang=ts&"
import style0 from "./OnePage.vue?vue&type=style&index=0&id=4138abe5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4138abe5",
  null
  
)

export default component.exports